import { useEffect } from 'react';
// eslint-disable-next-line
export const useDocumentTitle = (newTitle, { window = window }) => {
  useEffect(() => {
    const oldTitle = window.document.title;
    window.document.title = newTitle;
    return () => (window.document.title = oldTitle);
  });
};
